import {Component, OnInit, ViewChild} from '@angular/core';
import {OrbitaxExcelMemoService} from '../../orbitax-excel-memo.service';
import {ActivatedRoute, Router} from '@angular/router';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {takeUntil} from 'rxjs/operators';
import {corporateTax, viewMemoTitle, withholdingTax} from '../../orbitax-view-memo.constants';
import {combineLatest, Subject} from 'rxjs';
import {DialogModel} from '@shared/models/dialog.model';
import {CountryModel} from '@shared/models/country.model';
import {getAllCountries, ParticleState} from '@shared/store/reducers/particle.reduer';
import {select, Store} from '@ngrx/store';
import {DialogService} from '@shared/services/dialog-service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {WithHoldingTaxMemoModel} from '../../models/withholding-tax-memo.model';
import { MatSelect } from '@angular/material/select';
import { IPlatformToolComponent, IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { PlatformCommandResponse } from '@shared/commands/command-base';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import { MemoInfo } from '@features/excel-memo/models/memo-info';

@Component({
    standalone: false,
    selector: 'particle-withholding-tax-memo-content',
  templateUrl: './withholding-tax-memo-content.html',
  styleUrls: ['./withholding-tax-memo-content.scss']
})
export class WithholdingTaxMemoContentComponent implements OnInit, IPlatformToolComponent {
  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  invalidateSubject: InvalidateSubject;

  unsubscribe$ = new Subject<void>();
  private memoType: string;
  memoInfo: any;
  withholdingTaxMemo: WithHoldingTaxMemoModel;
  private id: string;
  date: any;
  allCountries: any[];
  availablePeriods: number[] = [];
  availablePercentage: number[] = [];
  inputForm: FormGroup;
  private payingCountryCode: string;
  private receivingCountryCode: string;
  paymentStream: any[];
  public initialCall: boolean;
  public matchingCountry = false;

  constructor(private formBuilder: FormBuilder,
              private particleStore: Store<ParticleState>,
              private dialogService: DialogService,
              private excelMemoService: OrbitaxExcelMemoService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private fuseSplashScreenService: FuseSplashScreenService) {


    this.inputForm =  this.formBuilder.group({
      payingCountry: ['', Validators.required],
      receivingCountry: ['', Validators.required],
      typeofPayment: ['', Validators.required],
      holdingPercentage: ['', Validators.required],
      holdingPeriod: ['', Validators.required]
    }, {
      validator: this.MustDifferent('payingCountry', 'receivingCountry')
    });
    this.matchingCountry = false;

    for (let i = 1; i <= 96; i++) {
      this.availablePeriods = [...this.availablePeriods, i];
    }
    for (let i = 0; i <= 100; i++) {
      this.availablePercentage = [...this.availablePercentage, i];
    }
  }


  onLoad() {
    const countries$ = this.particleStore.pipe(select(getAllCountries), takeUntil(this.unsubscribe$));
    const streams$ = this.excelMemoService.getPaymentStream();
    this.memoType = 'wt';
    this.id = this.magicLinkModel.fieldValues['MemoId'];

    combineLatest([countries$, streams$]).subscribe(response => {
      if(response[0] && response[1]) {
        this.allCountries = response[0];
        this.paymentStream = response[1];
        this.getWithholdingTaxMemo(this.id);
      }
    });
  }
  onBeforeExecuteNextCommand(): boolean {
    throw new Error('Method not implemented.');
  }
  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
    throw new Error('Method not implemented.');
  }
  onBeforeExecutePreviousCommand(): boolean {
    throw new Error('Method not implemented.');
  }
  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
    throw new Error('Method not implemented.');
  }
  ngOnInit() {

  }

  private refreshMemo() {
    if (this.withholdingTaxMemo) {
      if (this.withholdingTaxMemo.payingCountryCode && this.allCountries) {
        this.payingCountryCode = this.withholdingTaxMemo.payingCountryCode;
        this.inputForm.controls['payingCountry'].setValue(this.getCountryFromCountryCode(this.payingCountryCode).displayName);
      }
      if (this.withholdingTaxMemo.receivingCountryCode && this.allCountries) {
        this.receivingCountryCode = this.withholdingTaxMemo.receivingCountryCode;
        this.inputForm.controls['receivingCountry'].setValue(this.getCountryFromCountryCode(this.receivingCountryCode).displayName);
      }
      if (this.withholdingTaxMemo.streamCode && this.paymentStream) {
        const paymentStream = this.paymentStream.find(t => t.code === this.withholdingTaxMemo.streamCode);
        if (paymentStream && paymentStream.code) {
          this.inputForm.controls['typeofPayment'].setValue(paymentStream.code);
        }
      }
      if (this.withholdingTaxMemo.holdingPercentage != null) {
        this.inputForm.controls['holdingPercentage'].setValue(this.withholdingTaxMemo.holdingPercentage);
      }
      if (this.withholdingTaxMemo.holdingPeriod) {
        this.inputForm.controls['holdingPeriod'].setValue(this.withholdingTaxMemo.holdingPeriod);
      }
  }
}

  private getWithholdingTaxMemo(id: string) {
    this.fuseSplashScreenService.show();
    this.excelMemoService.getWithholdingTaxMemo(this.id).subscribe( (o: any) => {
      this.fuseSplashScreenService.hide();
      this.memoInfo = o;
      this.withholdingTaxMemo = this.memoInfo.withholdingTaxMemo;
      this.refreshMemo();
      this.subscribeOnChanges();
    });
  }

  subscribeOnChanges() {
    const subscribeFormControls = ['typeofPayment', 'holdingPercentage', 'holdingPeriod'];
    subscribeFormControls.forEach(formControlName => {
      this.inputForm.controls[formControlName].valueChanges.subscribe((value) => {
        this.updateMemoField(this.capitalize(formControlName), value);
      })
    });
  }

  capitalize(key: string): string {
    return key.charAt(0).toUpperCase() + key.slice(1);
  }

  updateMemoField(key: string, value: any) {
    const memoInfo: MemoInfo = {id: this.id, type: 'wt'};
    const editedField = {key, value};
    this.excelMemoService.updateMemoField(memoInfo, this.magicLinkModel, editedField, (response) => {
      this.memoInfo = response.fieldValues['MemoModel'];
      this.withholdingTaxMemo = this.memoInfo.withholdingTaxMemo;
      if(response.fieldValues['RefreshBreadcrumbBar']) {
        this.handler.valueChanged({action: 'Refresh', name: 'RefreshBreadcrumbBar'});
      }
    });
  }

  showPayingCountryDialogue() {
    this.excelMemoService.showCountryDialgogue('Paying Country', this.payingCountryCode, (country) => {
      if(this.payingCountryCode != country.code) {
        this.payingCountryCode = country.code;
        this.inputForm.controls['payingCountry'].setValue(country.displayName);
        this.updateMemoField('PayingEntity', country.code);
      }
    });
  }

  showReceivingCountryDialogue() {
    this.excelMemoService.showCountryDialgogue('Receiving Country', this.receivingCountryCode, (country) => {
      if(this.receivingCountryCode != country.code) {
        this.receivingCountryCode = country;
        this.inputForm.controls['receivingCountry'].setValue(country.displayName);
        this.updateMemoField('ReceivingEntity', country.code);
      }
    });
  }

  private MustDifferent(payingControlName: string, receivingControlName: string) {
    return (formGroup: FormGroup) => {
      const payingControl = formGroup.controls[payingControlName];
      const receivingControl = formGroup.controls[receivingControlName];

      if (payingControl.value && receivingControl.value) {
        if (payingControl.value === receivingControl.value) {
          this.matchingCountry = true;
          payingControl.setErrors({mustDifferent: true});
          receivingControl.setErrors({mustDifferent: true});
        } else {
          this.matchingCountry = false;
          payingControl.setErrors(null);
          receivingControl.setErrors(null);
        }
      }
    };
  }

  private getCountryFromCountryCode(countryCode: string) {
    return this.allCountries.find(t => t.code === countryCode);
  }

  viewMemo() {
    this.router.navigate(['view'], {relativeTo: this.activatedRoute});
  }

}
